import Button from '@rio-cloud/rio-uikit/Button';
import useDarkMode from '@rio-cloud/rio-uikit/hooks/useDarkMode';
import { useIntl } from 'react-intl';

import {
  ButtonContainer,
  ChatContainer,
  SpeechBubbleRobot,
  Text,
  Title,
} from '@/components/molecule/AnimatedRobotSpeechBubble/AnimatedRobotSpeechBubble.styles';

export type RobotMessage = {
  title?: string;
  text: string;
  buttons?: {
    text: string;
    onClick: () => void;
    dataTestId?: string;
  }[];
};

type AnimatedRobotSpeechBubbleRobotProps = {
  messages: RobotMessage[];
};

const AnimatedRobotSpeechBubbleRobot = ({ messages }: AnimatedRobotSpeechBubbleRobotProps) => {
  const intl = useIntl();

  const isDarkMode = useDarkMode();

  const buttonClass = isDarkMode ? 'btn btn-secondary btn-sm' : 'btn btn-outline btn-secondary btn-sm';

  return (
    <ChatContainer>
      {messages.map((msg, index) => (
        <SpeechBubbleRobot key={index} $delay={index * 0.5}>
          {msg.title ? <Title>{intl.formatMessage({ id: msg.title })}</Title> : null}
          <Text>{intl.formatMessage({ id: msg.text })}</Text>
          {msg.buttons ? (
            <ButtonContainer>
              {msg.buttons.map((button, i) => (
                <Button
                  key={i}
                  type="button"
                  className={buttonClass}
                  onClick={button.onClick}
                  data-testid={button.dataTestId}
                >
                  {intl.formatMessage({ id: button.text })}
                </Button>
              ))}
            </ButtonContainer>
          ) : null}
        </SpeechBubbleRobot>
      ))}
    </ChatContainer>
  );
};

export default AnimatedRobotSpeechBubbleRobot;
